<template>
  <vs-card class="overflow-hidden">
    <div class="flex justify-between" slot="header">
      <h2>Radar Chart</h2>
      <vx-tooltip title="Generate Graph" position="bottom">
        <vs-button
          type="border"
          icon="keyboard_arrow_down"
          @click="openGenerate = !openGenerate"
                                                          v-if="checkGeneratePermission()"

        ></vs-button>
      </vx-tooltip>
    </div>

    <!-- {{platform_modules}} -->
    <!-- {{ dateRange }} -->
    <div class="form_field_holder" :class="{ show: openGenerate }">
    

      <div class="flex flex-wrap items-center">
          
        <div class="lg:w-1/4 md:w-1/2 w-full p-2">
          <label>Module List</label>

          <v-select
            class="w-full"
            :options="get_platform_modules_item_data"
            label="module_name"
            :reduce="(item) => item.platform_modules_id"
            v-model="platform_module_id"
          ></v-select>
          <!-- {{ platform_module_id }} -->
        </div>
          <div class="lg:w-1/4 md:w-1/2 w-full p-2">
          <label>Select Date</label>

          <date-range-picker
        ref="picker"
        class="w-full"
        :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
        :showWeekNumbers="true"
        :showDropdowns="true"
        :autoApply="true"
        :ranges="customDateRanges()"
        v-model="dateRange"
      >
        <template v-slot:input="picker" style="min-width: 350px">
          {{ picker.startDate | date }} - {{ picker.endDate | date }}
        </template>
      </date-range-picker>
          <!-- {{ platform_module_id }} -->
        </div>
       
        <div class="lg:w-1/4 md:w-1/2 w-full p-2">
          <label>X Axis</label>
          <v-select
            class="w-full"
            :options="xAxisFieldOption"
            v-model="xAxisFieldId"
            :reduce="(item) => item.id"
            label="name"
          ></v-select>
        </div>
        <div class="lg:w-1/4 md:w-1/2 w-full p-2">
          <label>Y Axis</label>
          <!-- {{ yAxisFieldOption }} -->
          <v-select
            class="w-full"
            :options="yAxisFieldOption"
            v-model="yAxisFieldId"
            :reduce="(item) => item.id"
            label="name"
          ></v-select>
        </div>
      </div>
      <div class="p-2 sm:flex justify-between">
        <vs-button class="my-1" :disabled="!allFieldsSelected" @click="generateGraphApi"
          >Generate Graph</vs-button
        >
        <vs-button class="my-1" :disabled="!saveGraphChecking" @click="openSavePopUp()"
                        v-if="checkSaveModulePermission()"

          >Save this Graph</vs-button
        >
      </div>
    </div>
    <div id="chart">
      <apexchart
        type="radar"
        height="350"
        :options="chartOptions"
        :series="series"
        ref="apexChart"
      ></apexchart>
    </div>
    <div v-if="saveGraphPopUp">
      <vs-popup
        class="holamundo"
        title="Graph"
        :active.sync="saveGraphPopUp"
      >
        <SaveGraphComponent
          :graph_type="GRAPH_TYPE"
          :x_axis="xAxisFieldId"
          :y_axis="yAxisFieldId"
          :platform_module_id="platform_module_id"
          :dateRange="dateRange"
          @closeSavePopUp="closeSavePopUp"
        >
        </SaveGraphComponent>
      </vs-popup>
    </div>
  </vs-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { BarLineAreaMixins } from '../mixins/BarLineAreaMixins'
import SaveGraphComponent from './SaveGraphComponent.vue'
import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually (in case you want to override it)
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

import vSelect from 'vue-select'
export default {
  components: {
    vSelect,
    apexchart: VueApexCharts,
    SaveGraphComponent,
    DateRangePicker
  },
  mixins: [BarLineAreaMixins],
  props: {
    platform_modules: {
      type: Array,
      required: true,
      default: () => []
    },
    SelectedRadarGraphId: {}
  },
  data () {
    return {
      saveGraphPopUp:false,
      dateRange: {},
      GRAPH_TYPE: 'radar',
      openGenerate: false,
      platform_module_id: null,
      xAxisFieldOption: [],
      yAxisFieldOption: [],
      xAxisFieldId: null,
      yAxisFieldId: null,
      platform_field_x: null,
      platform_field_y: null,
      options: [],
      series: [
        {
          name: 'Desktops',
          data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
        }
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: 'radar',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        title: {
          // text: 'Product Trends by Month',
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        colors:[JSON.parse(localStorage.getItem('localization')).secondary_color],

        xaxis: {
          categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep'
          ]
        }
      }
    
    }
  },
  created () {
    
  },
  watch: {
    SelectedRadarGraphId () {
      if (this.SelectedRadarGraphId) {
        this.getGenratedSaveData(this.SelectedRadarGraphId, 'radar')
        this.generateGraph = false
      }
    }
  }
}
</script>
